import { Div, Ref, HandlersCollection, Link, Text } from "@tblabs/truffle";
import moment from "moment";
import { DateTimeProvider } from "../../Services/DateTimeProvider";
import { Svg } from "../Utils/Svg";


export class MonthSwitcher extends Div
{
    public month = new Ref<number>(this.startAt?.getMonth() || 0).Storable("month");
    public year = new Ref<number>(this.startAt?.getFullYear() || new Date().getFullYear()).Storable("year");

    public get AsDate(): moment.Moment
    {
        return moment().year(this.year.value).month(this.month.value).date(1);
    }

    private readonly MonthsNames = [
        "Styczeń", "Luty", "Marzec", "Kwiecień",
        "Maj", "Czerwiec", "Lipiec", "Sierpień",
        "Wrzesień", "Październik", "Listopad", "Grudzień"
    ];

    private onChange = new HandlersCollection<(month: number, year: number) => void>();
    public OnChange(handler: (month: number, year: number) => void)
    {
        this.onChange.Add(handler);
    }

    constructor(private startAt?: Date)
    {
        super("MonthSwitcher");

        this.month.OnChange(v => this.onChange.Call(v, this.year.value));
        this.year.OnChange(v => this.onChange.Call(this.month.value, v));

        this.Append(
            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left-icon lucide-chevron-left"><path d="m15 18-6-6 6-6"/></svg>`)
                .OnClick(() =>
                {
                    if (this.month.value <= 0)
                    {
                        this.year.value--;
                        this.month.value = 11;
                        return;
                    }
                    this.month.value--;
                }).FloatLeft()//.Margin(4)
                ,

            new Text(this.month, v => this.MonthsNames[+v]).FontSize(16)
                .OnClick(() =>
                {
                    this.month.value = DateTimeProvider.Now.getMonth();
                    this.onChange.Call(this.month.value, this.year.value)
                }),

            new Text(this.year).Margin(12).FontSize(16)
                .OnClick(() =>
                {
                    this.year.value = DateTimeProvider.Now.getFullYear();
                    this.onChange.Call(this.month.value, this.year.value)
                }),

            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right-icon lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>`)
                .OnClick(() =>
                {
                    if (this.month.value >= 12 - 1)
                    {
                        this.year.value++;
                        this.month.value = 0;
                        return;
                    }
                    this.month.value++;
                }).FloatRight()//.Margin(4)
        );
    }
}
